"use client";

import { Button } from "@/components/ui/button";

/**
 * The catalogue read fell over — stated, instead of drawn as an empty catalogue.
 *
 * `CatalogEmpty` says "nothing here" and offers to widen the filters; after a failed request
 * that is a claim nobody can make, and the host either widens filters that were never the
 * problem or concludes the brand's catalogue is gone. Same shape as the statement of the
 * extract's failure (`EntriesError`), which is the panel's own way of saying it.
 *
 * **No pending state on the button, deliberately.** React Query clears `isError` when the
 * fetch restarts, so this block unmounts on the tap itself; the grid skeleton answers for
 * the interval.
 */
export function CatalogError({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      role="alert"
      // The top margin is `CatalogEmpty`'s, since this stands where that would: the failure
      // takes the grid's place and has to sit on the same line the empty state sits on.
      className="mt-[clamp(24px,3vw,40px)] flex flex-col items-center gap-3 px-[clamp(24px,3vw,40px)] py-[clamp(40px,5vw,64px)] text-center motion-safe:animate-[tb-fade-in_var(--tb-duration-3)_var(--tb-ease-linen)_both]"
    >
      <h3 className="font-display text-[clamp(18px,2.02vw,23px)] font-light uppercase leading-[1.12]">
        Não conseguimos <em className="text-tb-green">carregar</em>.
      </h3>

      <p className="max-w-[46ch] text-[14px] leading-[1.6] text-[var(--fg-muted)] [text-wrap:pretty]">
        A sua lista continua como está. Foi a busca do catálogo que não completou.
      </p>

      {/* The DS button, with the panel's own measurements: `architecture-standards.md` §Design
          System asks every interactive element to be a DS component, and taking it also takes
          the focus ring, which the panel's hand-rolled retry buttons do not have. */}
      <Button
        variant="outline"
        onClick={onRetry}
        className="mt-2 h-auto min-h-[var(--tb-touch-min)] px-[26px] py-[18px] text-[13px] tracking-[0.14em] duration-[var(--tb-duration-2)] ease-[var(--tb-ease-linen)]"
      >
        Tentar de novo
      </Button>
    </div>
  );
}
